import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "invoice-cost-tr" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Cost per hour"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Time"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col"
    }, "Total cost"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col",
      width: "2%"
    })
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_InvoiceItemMenu = _resolveComponent("InvoiceItemMenu")!

  return (_openBlock(), _createElementBlock("table", null, [
    _hoisted_1,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.staffHours, (staffHour, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: `staff-hour-${staffHour.id}-${index}`
        }, [
          (staffHour.staff_name?.length > 15)
            ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                _createVNode(_component_NrTooltip, {
                  label: staffHour.staff_name
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.truncate(staffHour.staff_name, { length: 15 })), 1)
                  ]),
                  _: 2
                }, 1032, ["label"])
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(staffHour.staff_name), 1)),
          _createElementVNode("td", null, _toDisplayString(staffHour?.hourly_rate || staffHour?.staff_hourly_rate || '$0.00'), 1),
          _createElementVNode("td", null, _toDisplayString(staffHour.staff_hour), 1),
          _createElementVNode("td", _hoisted_4, _toDisplayString(staffHour.staff_cost), 1),
          _createElementVNode("td", null, [
            _createVNode(_component_InvoiceItemMenu, {
              onOnEdit: ($event: any) => ($options.onEdit(staffHour)),
              onOnDelete: ($event: any) => ($options.onDelete(staffHour))
            }, null, 8, ["onOnEdit", "onOnDelete"])
          ])
        ]))
      }), 128))
    ])
  ]))
}